export class MethodDescription {
	name: string;
	fields: string[];
	usesToken = false;
}
